<p-card>
  <ng-template #content>
    @if (filter) {
      <div class="px-2">
        <p-iconfield>
          <p-inputicon styleClass="pi pi-search" />
          <input
            type="text"
            pInputText
            class="w-full"
            placeholder="Search"
            [ngModel]="searchStr"
            (input)="searchFilter($event)"
          />
        </p-iconfield>
      </div>
    }

    <div class="listbox-container">
      @if (ShowEmptyFilterMessage) {
        <span class="font-semibold px-2 py-1">{{ emptyFilterMessage }}</span>
      } @else if (Groups.length) {
        <p-accordion
          [activeIndex]="TabActiveIndex"
          [multiple]="multiple"
          (onOpen)="accordionOpen($event)"
          (onClose)="accordionClose($event)"
        >
          @for (group of Groups; track $index) {
            <!-- <span class="listbox-group font-semibold">{{ group }}</span> -->
            <p-accordion-panel>
              <p-accordion-header>
                {{ group }}
              </p-accordion-header>
              <p-accordion-content>
                <ng-container
                  *ngTemplateOutlet="
                    optionsTemplate;
                    context: {
                      options: OptionsByGroup[group],
                    }
                  "
                ></ng-container>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      } @else {
        <ng-container
          *ngTemplateOutlet="
            optionsTemplate;
            context: {
              options: Options,
            }
          "
        ></ng-container>
      }
    </div>
  </ng-template>
</p-card>

<ng-template #optionsTemplate let-options="options">
  @for (option of options; track $index) {
    <span
      tabindex="0"
      class="listbox-item"
      [ngClass]="{
        highlight: isEqual(
          optionValue ? $any(option)[optionValue] : option,
          value
        ),
      }"
      (click)="option !== value && onOptionClicked(option)"
      (keyup.enter)="option !== value && onOptionClicked(option)"
      (keyup.space)="option !== value && onOptionClicked(option)"
    >
      @if (itemTemplate) {
        <ng-container
          *ngTemplateOutlet="itemTemplate; context: { $implicit: option }"
        ></ng-container>
      } @else {
        {{ $any(option)[optionLabel] }}
      }
    </span>
  }
</ng-template>
